/**
 * Design tokens from the Vercel reference build
 * (clutter-home-desktop / index-CFMvqtlV.css).
 */
const SECTION_BG_DARK = '#1F2F38';

export const TOKENS = {
  color: {
    background: '#f6f7f5',
    backgroundMuted: '#e6e2d7',
    /** Design system section-bg-dark / section-bg-secondary (Night Slate). */
    sectionBgDark: SECTION_BG_DARK,
    backgroundDark: SECTION_BG_DARK,
    foreground: '#040711',
    foregroundSecondary: '#263e45',
    /** Design system image-overlay on hero photography. */
    imageOverlay: 'rgba(4, 7, 17, 0.3)',
    foregroundMuted: '#1f2f38b8',
    onDark: '#ffffffe6',
    /** Design system text-secondary on dark backgrounds. */
    onDarkMuted: '#9AA1A5',
    textSecondaryOnDark: '#9AA1A5',
    inverse: '#F6F7F5',
    muted: '#1f2f38b8',
    primary: '#0b7a79',
    primaryHover: '#08AAA8',
    primaryHover_24: '#08aaa83d',
    primaryBright: '#04e9e6',
    portal: '#11a3a3',
    portal_10: '#11a3a31a',
    portal_24: '#11a3a33d',
    primaryForeground: '#f6f7f5',
    brandOnPrimary: '#011a1a',
    neutral200: '#c8d1d3',
    neutral0_5: '#ffffff0d',
    neutral0_7: '#ffffff12',
    neutral0_10: '#ffffff1a',
    neutral0_12: '#ffffff1f',
    neutral0_20: '#ffffff33',
    neutral0_30: '#ffffff4d',
    neutral0_50: '#ffffff80',
    neutral950_5: '#0000000d',
    neutral950_10: '#0000001a',
    neutral950_20: '#00000033',
    neutral950_30: '#0000004d',
    neutral950_32: '#00000052',
    neutral950_40: '#00000066',
    neutral950_60: '#00000099',
    neutral950_64: '#000000a3',
    neutral950_85: '#040711d9',
    neutral900_40: '#1f2f3866',
    neutral900_97: '#1f2f38f7',
    neutral500_30: '#8282824d',
    neutral500_40: '#82828266',
    border: '#9aa1a54d',
    borderSubtle: '#82828266',
    overlayScrim: '#0000004d',
    overlayTint: '#effefb1a',
    inverseSurface: '#f9fafb0d',
    surfaceInverseHover: '#ffffff1a',
    brand500_10: '#effefb1a',
    brand500_24: '#0b7a793d',
    brand500_40: '#0b7a7966',
    iconDark: SECTION_BG_DARK,
    iconFillAccent: '#C6AA77',
    iconFillLight: '#F6F7F5',
    iconBgLight: '#ffffff1a',
    ring: '#C6AA77',
    ringOffset: '#f6f7f5',
    error: '#d14343',
    errorBanner: 'rgba(31, 47, 56, 0.88)',
  },
  space: {
    4: '4px',
    8: '8px',
    12: '12px',
    16: '16px',
    24: '24px',
    32: '32px',
    40: '40px',
    48: '48px',
    64: '64px',
    80: '80px',
    128: '128px',
  },
  radius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '20px',
    pill: '999px',
  },
  font: {
    display: '"EB Garamond", Georgia, "Times New Roman", serif',
    sans: '"Avenir Next", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  type: {
    bodyMdSize: '17px',
    bodyMdLineHeight: '25px',
    bodyMdWeight: 500,
    bodySmSize: '15px',
    bodySmLineHeight: '22px',
    bodySmWeight: 500,
    headingH3Size: '20px',
    headingH3LineHeight: '24px',
    headingH3Weight: 500,
    labelSmSize: 'clamp(12px, calc(12px + 2 * ((100vw - 375px) / 1065)), 14px)',
    labelSmLineHeight:
      'clamp(20px, calc(20px + 3 * ((100vw - 375px) / 1065)), 23px)',
    labelSmWeight: 500,
    headingH1Size:
      'clamp(42px, calc(42px + 22 * ((100vw - 375px) / 1065)), 64px)',
    headingH1LineHeight:
      'clamp(53px, calc(53px + 27 * ((100vw - 375px) / 1065)), 80px)',
    headingH2Size:
      'clamp(27px, calc(27px + 13 * ((100vw - 375px) / 1065)), 40px)',
    headingH2LineHeight:
      'clamp(34px, calc(34px + 16 * ((100vw - 375px) / 1065)), 50px)',
    headingH1Weight: 500,
    headingH2Weight: 500,
  },
  headerOffset: '98px',
  sectionMaxWidth: '1480px',
} as const;

export const MEDIA = {
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 1024px)',
  xl: '@media (min-width: 1280px)',
  xxl: '@media (min-width: 1536px)',
} as const;
